<template>
    <v-row
        no-gutters
        class="pl-9 pr-8 pt-8"
    >
        <v-col>
            <div class="mb-2">
                <switch-button
                    :label="$t('Clients can leave task messages by replying to client portal email')"
                    :value="clientsCanLeaveTaskMessagesByReplyingToClientPortalEmail"
                    @change="onUpdateClientsCanLeaveTaskMessagesByReplyingToClientPortalEmail"
                />
            </div>
            <div class="mb-2">
                <switch-button
                    :label="$t('Send a copy of client\'s response to member\'s inbox')"
                    :value="cpBlindCopyEnabled"
                    @change="onUpdateCpBlindCopyEnabled"
                />
            </div>
            <div class="mb-2">
                <switch-button
                    :label="$t('Email recipients can leave task comments by replying to a task email')"
                    :value="emailRecipientsCanLeaveTaskComments"
                    @change="onUpdateEmailRecipientsCanLeaveTaskComments"
                />
            </div>
        </v-col>
    </v-row>
</template>

<script>
import {ref} from "@vue/composition-api";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import {$t} from "@/i18n";
import IntegrationButton from "@/components/Buttons/IntegrationButton";
import EditEmailIntegration from "@/components/Dialog/EmailIntegration/Index"
import errorDialog from "@/views/ErrorDialog/errorDialog";
import ApiAppStore from "@/api/app_store/appStore"
import EmailIntegrationModule from "@/modules/emailIntegration/emailIntegration"
import AppModule from "@/store/modules/app"

export default {
    name: "EmailingSettingsTab",
    components: {
        IntegrationButton,
        EditEmailIntegration
    },
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const { sending_email } = AppModule()
        const {appStoreDialogGetters} = appStoreDialog()

        const accountFeatureSettings = appStoreDialogGetters.getCurrentFeatureSettings()

        const clientsCanLeaveTaskMessagesByReplyingToClientPortalEmail = ref(accountFeatureSettings && accountFeatureSettings.data ? accountFeatureSettings.data.clients_can_leave_task_messages_by_replying_to_client_portal_email : false)
        const cpBlindCopyEnabled = ref(accountFeatureSettings && accountFeatureSettings.data ? accountFeatureSettings.data.cp_blind_copy_enabled : false)
        const emailRecipientsCanLeaveTaskComments = ref(accountFeatureSettings && accountFeatureSettings.data ? accountFeatureSettings.data.email_recipients_can_leave_task_comments : false)

        const updateAccountFeatureSettings = async () => {
            try {
                let accountFeatureSettings = appStoreDialogGetters.getCurrentFeatureSettings() || {}
                let data = accountFeatureSettings.data || {}
                data['cp_blind_copy_enabled'] = cpBlindCopyEnabled.value ? 1 : 0
                data['clients_can_leave_task_messages_by_replying_to_client_portal_email'] = clientsCanLeaveTaskMessagesByReplyingToClientPortalEmail.value ? 1 : 0
                data['email_recipients_can_leave_task_comments'] = emailRecipientsCanLeaveTaskComments.value ? 1 : 0

                const accountFeature = appStoreDialogGetters.getCurrentFeature()
                const selectedAccount = appStoreDialogGetters.getSelectedCompany()

                await ApiAppStore.saveAppSettings(
                    selectedAccount.id,
                    accountFeature.feature_id,
                    data
                )

            } catch (e) {
                errorDialog.showError(e)
            }
        }

        const onUpdateCpBlindCopyEnabled = (value) => {
            cpBlindCopyEnabled.value = value
            updateAccountFeatureSettings()
        }

        const onUpdateClientsCanLeaveTaskMessagesByReplyingToClientPortalEmail = (value) => {
            clientsCanLeaveTaskMessagesByReplyingToClientPortalEmail.value = value
            updateAccountFeatureSettings()
        }

        const onUpdateEmailRecipientsCanLeaveTaskComments = (value) => {
            emailRecipientsCanLeaveTaskComments.value = value
            updateAccountFeatureSettings()
        }

        return {
            EmailIntegrationModule,
            clientsCanLeaveTaskMessagesByReplyingToClientPortalEmail,
            cpBlindCopyEnabled,
            emailRecipientsCanLeaveTaskComments,
            sending_email,
            onUpdateCpBlindCopyEnabled,
            onUpdateClientsCanLeaveTaskMessagesByReplyingToClientPortalEmail,
            onUpdateEmailRecipientsCanLeaveTaskComments
        };
    }
};
</script>
